// ErrorPopupContext.js
import React, { createContext, useContext, useState } from "react";

const ErrorPopupContext = createContext();

export const useErrorPopup = () => useContext(ErrorPopupContext);

export const ErrorPopupProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const showError = (message) => {
    setErrorMessage(message);
    setIsOpen(true);
  };

  const hideError = () => {
    setIsOpen(false);
    setErrorMessage(null);
  };

  return (
    <ErrorPopupContext.Provider value={{ errorMessage, showError, hideError }}>
      {children}
    </ErrorPopupContext.Provider>
  );
};
